module.exports = __webpack_public_path__ + "img/icon-line-horizontal.208a4bb3.svg";